import { AfterViewInit, Component, EventEmitter, OnInit } from '@angular/core';
import { IDateRangePickerDashboardItem } from 'src/app/components/date-picker/date-picker.component';
import { IMultipleSelectDashboardItem } from 'src/app/components/multiple-select/multiple-select.component';
import { IDashboardItemDataLoaderLink } from 'src/app/services/dashboard-item/IDashboardItemDataLoaderLink';
import { DashboardService } from 'src/app/services/dashboard/dashboard.service';
import { IDataLoaderResult } from 'src/app/services/data-loader/data-loader-result';
import { DataLoaderFactories } from 'src/app/services/data-loader/data-loader.service';
import {
    IQueryContext,
    QueryContextSettingID,
} from 'src/app/services/query-context/models/IQueryContext';
import { QueryContextService } from 'src/app/services/query-context/query-context.service';
import { DatasourceColumnId } from 'src/app/utils/datasource-sql-map/datasource';
import { EChartsAxisHelper } from 'src/app/utils/echarts/echarts-axis-helper';
import { EChartsTooltipHelper } from 'src/app/utils/echarts/echarts-tooltip-helper';
import { defaultColorGetterBuilder } from 'src/app/utils/echarts/series-color';
import { GcpProjectId } from 'src/app/utils/gcp-project-id.model';
import { currentDataProject } from 'src/app/services/data-project/models/data-project.model';
import { SegmentDatasourceColumnDataLoaderFactoryOptions } from '../common/data-loaders/segments';
import { DashboardItemFactories } from '../common/items/common-dashboard-items';
import { ModifyTimeDashboardItemFactory } from '../common/items/modify-time';
import { IToggleSettingDashboardItem } from '../common/items/setting/toggle/toggle.component';
import { StandardDashboardWorker } from '../common/standard-dashboard';
import { MopaCustomFunnelsChartDocs } from './mopa-custom-funnels.chart-documentation';
import { CustomFunnelsUsersByStepDataLoaderFactory } from './data-loaders/custom-funnels-users-by-step';
import { BiVizDashboardFunnels } from './sql-maps/biviz-dashboard-funnels-datasource-sql-map';

@Component({
    selector: 'mopa-custom-funnels.component',
    templateUrl: './mopa-custom-funnels.component.html',
    styleUrls: ['./mopa-custom-funnels.component.scss'],
    providers: [DashboardService, QueryContextService],
})
export class MopaCustomFunnelsComponent
    extends StandardDashboardWorker
    implements OnInit, AfterViewInit
{
    override DASHBOARD_NAME = 'Custom_Funnels';
    override DASHBOARD_ID = 'mopa-custom-funnels';

    values = Object.values;

    private defaultGcpProjectId: GcpProjectId =
        currentDataProject().gcpProjectId;

    /////////////////////////////////////////////////////////////////
    ////
    ////    DATALOADERS
    ////    Some DataLoader can be used in multiple charts.
    ////    That's why there are created here and later referenced
    ////
    /////////////////////////////////////////////////////////////////

    override filterDataLoaders = {
        'mopa.custom_funnels.filter.funnel_name': DataLoaderFactories[
            'common.filter.datasource_column'
        ]({
            createdInstanceId: 'mopa.custom_funnels.filter.funnel_name',
            gcpProjectId: this.defaultGcpProjectId,
            queryCacheService: this.queryCache,
            datasourceColumnId: 'CUSTOM_FUNNELS_FUNNEL_NAME',
            datasourceSqlMap: BiVizDashboardFunnels.sqlMap,
        }).create(),
        'mopa.custom_funnels.filter.step_group': DataLoaderFactories[
            'common.filter.datasource_column'
        ]({
            createdInstanceId: 'mopa.custom_funnels.filter.step_group',
            gcpProjectId: this.defaultGcpProjectId,
            queryCacheService: this.queryCache,
            datasourceColumnId: 'CUSTOM_FUNNELS_STEP_GROUP',
            datasourceSqlMap: BiVizDashboardFunnels.sqlMap,
        }).create(),
        'mopa.custom_funnels.filter.step_id': DataLoaderFactories[
            'common.filter.datasource_column'
        ]({
            createdInstanceId: 'mopa.custom_funnels.filter.step_id',
            gcpProjectId: this.defaultGcpProjectId,
            queryCacheService: this.queryCache,
            datasourceColumnId: 'CUSTOM_FUNNELS_STEP_ID',
            datasourceSqlMap: BiVizDashboardFunnels.sqlMap,
        }).create(),
        'mopa.custom_funnels.filter.step_name': DataLoaderFactories[
            'common.filter.datasource_column'
        ]({
            createdInstanceId: 'mopa.custom_funnels.filter.step_name',
            gcpProjectId: this.defaultGcpProjectId,
            queryCacheService: this.queryCache,
            datasourceColumnId: 'CUSTOM_FUNNELS_STEP_NAME',
            datasourceSqlMap: BiVizDashboardFunnels.sqlMap,
        }).create(),
        // 'mopa.custom_funnels.filter.out_replays': DataLoaderFactories[
        //     'common.filter.datasource_column'
        // ]({
        //     createdInstanceId: 'mopa.custom_funnels.filter.out_replays',
        //     gcpProjectId: this.defaultGcpProjectId,
        //     queryCacheService: this.queryCache,
        //     datasourceColumnId: 'CUSTOM_FUNNELS_OUT_REPLAYS',
        //     datasourceSqlMap: BiVizDashboardFunnels.sqlMap,
        // }).create(),
        // 'mopa.custom_funnels.filter.first_game_eni2': DataLoaderFactories[
        //     'common.filter.datasource_column'
        // ]({
        //     createdInstanceId: 'mopa.custom_funnels.filter.first_game_eni2',
        //     gcpProjectId: this.defaultGcpProjectId,
        //     queryCacheService: this.queryCache,
        //     datasourceColumnId: 'CUSTOM_FUNNELS_FIRST_GAME_ENI2',
        //     datasourceSqlMap: BiVizDashboardFunnels.sqlMap,
        // }).create(),
        'mopa.custom_funnels.filter.segment': DataLoaderFactories[
            'common.filter.segment'
        ](
            new SegmentDatasourceColumnDataLoaderFactoryOptions(
                'mopa.custom_funnels.filter.segment',
                this.defaultGcpProjectId,
                this.queryCache
            )
        ).create(),
        'mopa.custom_funnels.filter.firebase_app_store': DataLoaderFactories[
            'common.filter.datasource_column'
        ]({
            createdInstanceId: 'mopa.custom_funnels.filter.firebase_app_store',
            gcpProjectId: this.defaultGcpProjectId,
            queryCacheService: this.queryCache,
            datasourceColumnId: 'FIREBASE_APP_STORE',
            datasourceSqlMap: BiVizDashboardFunnels.sqlMap,
        }).create(),
        'mopa.custom_funnels.filter.firebase_country_european_union':
            DataLoaderFactories['common.filter.datasource_column']({
                createdInstanceId:
                    'mopa.custom_funnels.filter.firebase_country_european_union',
                gcpProjectId: this.defaultGcpProjectId,
                queryCacheService: this.queryCache,
                datasourceColumnId: 'FIREBASE_COUNTRY_EUROPEAN_UNION',
                datasourceSqlMap: BiVizDashboardFunnels.sqlMap,
            }).create(),
        'mopa.custom_funnels.filter.firebase_country_tier': DataLoaderFactories[
            'common.filter.datasource_column'
        ]({
            createdInstanceId:
                'mopa.custom_funnels.filter.firebase_country_tier',
            gcpProjectId: this.defaultGcpProjectId,
            queryCacheService: this.queryCache,
            datasourceColumnId: 'FIREBASE_COUNTRY_TIER',
            datasourceSqlMap: BiVizDashboardFunnels.sqlMap,
        }).create(),
        'mopa.custom_funnels.filter.firebase_country_is_relevant_label':
            DataLoaderFactories['common.filter.datasource_column']({
                createdInstanceId:
                    'mopa.custom_funnels.filter.firebase_country_is_relevant_label',
                gcpProjectId: this.defaultGcpProjectId,
                queryCacheService: this.queryCache,
                datasourceColumnId: 'FIREBASE_COUNTRY_IS_RELEVANT_LABEL',
                datasourceSqlMap: BiVizDashboardFunnels.sqlMap,
            }).create(),
        'mopa.custom_funnels.filter.firebase_country': DataLoaderFactories[
            'common.filter.datasource_column'
        ]({
            createdInstanceId: 'mopa.custom_funnels.filter.firebase_country',
            gcpProjectId: this.defaultGcpProjectId,
            queryCacheService: this.queryCache,
            datasourceColumnId: 'FIREBASE_COUNTRY',
            datasourceSqlMap: BiVizDashboardFunnels.sqlMap,
        }).create(),
        'mopa.custom_funnels.filter.attribution_traffic_source':
            DataLoaderFactories['common.filter.datasource_column']({
                createdInstanceId:
                    'mopa.custom_funnels.filter.attribution_traffic_source',
                gcpProjectId: this.defaultGcpProjectId,
                queryCacheService: this.queryCache,
                datasourceColumnId: 'ATTRIBUTION_TRAFFIC_SOURCE',
                datasourceSqlMap: BiVizDashboardFunnels.sqlMap,
            }).create(),
        'mopa.custom_funnels.filter.attribution_network_name':
            DataLoaderFactories['common.filter.datasource_column']({
                createdInstanceId:
                    'mopa.custom_funnels.filter.attribution_network_name',
                gcpProjectId: this.defaultGcpProjectId,
                queryCacheService: this.queryCache,
                datasourceColumnId: 'ATTRIBUTION_NETWORK_NAME',
                datasourceSqlMap: BiVizDashboardFunnels.sqlMap,
            }).create(),
        'mopa.custom_funnels.filter.firebase_install_version_group_minor':
            DataLoaderFactories['common.filter.datasource_column']({
                createdInstanceId:
                    'mopa.custom_funnels.filter.firebase_install_version_group_minor',
                gcpProjectId: this.defaultGcpProjectId,
                queryCacheService: this.queryCache,
                datasourceColumnId: 'FIREBASE_INSTALL_VERSION_GROUP_MINOR',
                datasourceSqlMap: BiVizDashboardFunnels.sqlMap,
            }).create(),
        'mopa.custom_funnels.filter.firebase_install_version':
            DataLoaderFactories['common.filter.datasource_column']({
                createdInstanceId:
                    'mopa.custom_funnels.filter.firebase_install_version',
                gcpProjectId: this.defaultGcpProjectId,
                queryCacheService: this.queryCache,
                datasourceColumnId: 'FIREBASE_INSTALL_VERSION',
                datasourceSqlMap: BiVizDashboardFunnels.sqlMap,
            }).create(),
        'mopa.custom_funnels.filter.payer': DataLoaderFactories[
            'common.filter.datasource_column'
        ]({
            createdInstanceId: 'mopa.custom_funnels.filter.payer',
            gcpProjectId: this.defaultGcpProjectId,
            queryCacheService: this.queryCache,
            datasourceColumnId: 'ETL_PAYER',
            datasourceSqlMap: BiVizDashboardFunnels.sqlMap,
        }).create(),
        'mopa.custom_funnels.filter.revenue_badge': DataLoaderFactories[
            'common.filter.datasource_column'
        ]({
            createdInstanceId: 'mopa.custom_funnels.filter.revenue_badge',
            gcpProjectId: this.defaultGcpProjectId,
            queryCacheService: this.queryCache,
            datasourceColumnId: 'ETL_REVENUE_BADGE',
            datasourceSqlMap: BiVizDashboardFunnels.sqlMap,
        }).create(),
        'mopa.custom_funnels.filter.attribution_campaign_name':
            DataLoaderFactories['common.filter.datasource_column']({
                createdInstanceId:
                    'mopa.custom_funnels.filter.attribution_campaign_name',
                gcpProjectId: this.defaultGcpProjectId,
                queryCacheService: this.queryCache,
                datasourceColumnId: 'ATTRIBUTION_CAMPAIGN_NAME',
                datasourceSqlMap: BiVizDashboardFunnels.sqlMap,
            }).create(),
    };

    override chartDataLoaders = {
        'mopa.custom_funnels.modify_time_custom_funnels_datasource':
            DataLoaderFactories['common.modify_time']({
                createdInstanceId:
                    'mopa.custom_funnels.modify_time_custom_funnels_datasource',
                gcpProjectId: this.defaultGcpProjectId,
                queryCacheService: this.queryCache,
                datasetId: BiVizDashboardFunnels.sqlMap.dataset,
                tableId: BiVizDashboardFunnels.sqlMap.tableId,
            }).create(),
        'mopa.custom_funnels.custom_funnels_users_by_step':
            new CustomFunnelsUsersByStepDataLoaderFactory({
                createdInstanceId:
                    'mopa.custom_funnels.custom_funnels_users_by_step',
                gcpProjectId: this.defaultGcpProjectId,
                queryCacheService: this.queryCache,
            }).create(),
    };

    /////////////////////////////////////////////////////////////////
    ////
    ////    [DASHBOARD ITEM <-> DATALOADER] LINKS
    ////
    /////////////////////////////////////////////////////////////////

    // CHARTS
    modify_time_custom_funnels_datasource: IDashboardItemDataLoaderLink = {
        id: 'mopa.custom_funnels.modify_time_custom_funnels_datasource',
        dashboardItemFactory: new ModifyTimeDashboardItemFactory({
            createdInstanceId:
                'mopa.custom_funnels.modify_time_custom_funnels_datasource',
            columnId: 'value',
        }),
        dataLoaderEmitter:
            this.chartDataLoaders[
                'mopa.custom_funnels.modify_time_custom_funnels_datasource'
            ].emitter,
    };

    funnels_users_by_step_cnt: IDashboardItemDataLoaderLink = {
        id: 'mopa.custom_funnels.chart.funnels_users_by_step_cnt',
        dashboardItemFactory: DashboardItemFactories['common.chart.xy_chart']({
            dashboardName: this.DASHBOARD_NAME,
            createdInstanceId:
                'mopa.custom_funnels.chart.funnels_users_by_step_cnt',
            dashboardItem: {
                title: 'Funnels',
                chartDocumentation:
                    MopaCustomFunnelsChartDocs.funnels_users_by_step_cnt,
            },
            xAxisType: 'category',
            xAxisCategorySubtype: 'generic',
            xAxisLabelRotation: '90deg',
            xColumnLabel: 'step_name',
            yColumnLabel: 'percentage_of_first_step',
            yAxisLabel: {
                formatter: (v: number) =>
                    EChartsAxisHelper.axisPercentLabelFormatter(v, 0),
            },
            metricName: '% of first step',
            echartsSeriesType: 'bar',
            toolbox: {
                feature: {
                    export: {
                        // sortKeys: ['step_name'],
                        customColumns: [
                            {
                                key: 'step_id',
                                // postValue: (v: any) => Number(v),
                                name: 'Step ID',
                                rowKey: true,
                            },
                            {
                                key: 'step_name',
                                name: 'Step Name',
                                rowKey: true,
                                // sortKey: true,
                            },
                            {
                                key: 'step_group',
                                name: 'Step Group',
                                rowKey: true,
                            },
                            {
                                key: 'users_by_step',
                                name: 'Users',
                            },
                            {
                                key: 'percentage_of_first_step',
                                name: '% of first step',
                            },
                            {
                                key: 'percentage_of_previous_step',
                                name: '% of previous step',
                            },
                            {
                                key: 'used_energy_Q2',
                                name: 'Energy used since first step Q2',
                            },
                            {
                                key: 'time_since_first_step_min_Q2',
                                name: 'Time since first step min Q2',
                            },
                            {
                                key: 'time_since_previous_step_sec_Q2',
                                name: 'Time since previous step sec Q2',
                            },
                        ],
                    },
                },
            },
            tooltip: {
                valueFormatterGetter: () =>
                    EChartsTooltipHelper.tooltipPercentValueFormatter,
                secondaryMetricsGetter: (context) => {
                    return [
                        {
                            key: 'step_group',
                            name: 'Step Group',
                        },
                        {
                            key: 'percentage_of_previous_step',
                            name: '% of previous step',
                            formatter:
                                EChartsTooltipHelper.tooltipPercentValueFormatter,
                        },
                        {
                            key: 'users_by_step',
                            name: 'Users',
                        },
                        {
                            name: 'Q1-Q2 (Median)-Q3 Statistics',
                        },
                        {
                            key: 'used_energy',
                            name: 'Energy used since first step',
                        },
                        {
                            key: 'time_since_first_step_min',
                            name: 'Time since first step',
                        },
                        {
                            key: 'time_since_previous_step_sec',
                            name: 'Time since previous step',
                        },
                    ];
                },
            },
            colorGetterBuilder: (context: IQueryContext) => {
                return defaultColorGetterBuilder(this.colorService, context);
            },
        }),
        dataLoaderEmitter:
            this.chartDataLoaders[
                'mopa.custom_funnels.custom_funnels_users_by_step'
            ].emitter,
    };

    funnels_balance_info: IDashboardItemDataLoaderLink = {
        id: 'mopa.custom_funnels.chart.funnels_balance_info',
        dashboardItemFactory: DashboardItemFactories['common.chart.xy_chart']({
            dashboardName: this.DASHBOARD_NAME,
            createdInstanceId: 'mopa.custom_funnels.chart.funnels_balance_info',
            dashboardItem: {
                title: 'Balance info by step (for tooltip only)',
                chartDocumentation:
                    MopaCustomFunnelsChartDocs.funnels_balance_info,
            },

            // xAxis: {
            //     show: false,
            // },
            xAxisType: 'category',
            xAxisCategorySubtype: 'generic',
            xColumnLabel: 'step_id_str',
            yColumnLabel: 'balance',
            yAxis: {
                show: false,
            },
            yAxisLabel: {
                formatter: (v: number) => '',
            },
            metricName: 'Balance',
            echartsSeriesType: 'bar',
            seriesSymbolMethod: 'every',
            toolbox: {
                feature: {
                    export: {
                        // sortKeys: ['step_name'],
                        customColumns: [
                            {
                                key: 'step_id',
                                name: 'Step ID',
                                rowKey: true,
                            },
                            {
                                key: 'step_name',
                                name: 'Step Name',
                                rowKey: true,
                                sortKey: true,
                            },
                            {
                                key: 'step_group',
                                name: 'Step Group',
                                rowKey: true,
                            },
                            {
                                key: 'used_energy_Q2',
                                name: 'Energy used since first step Q2',
                            },
                            {
                                key: 'used_hints_Q2',
                                name: 'Hints used since first step Q2',
                            },
                            {
                                key: 'energy_current_Q2',
                                name: 'Energy Current Q2',
                            },
                            {
                                key: 'gems_current_Q2',
                                name: 'Gems Current Q2',
                            },
                            {
                                key: 'hints_current_Q2',
                                name: 'Hints Current Q2',
                            },
                        ],
                    },
                },
            },
            tooltip: {
                valueFormatterGetter: () => () => '',
                secondaryMetricsGetter: (context) => {
                    return [
                        {
                            key: 'step_name',
                            name: 'Step Name',
                        },
                        {
                            key: 'step_group',
                            name: 'Step Group',
                        },
                        {
                            name: 'Q1-Q2 (Median)-Q3 Statistics',
                        },
                        {
                            key: 'used_energy',
                            name: 'Energy used since first step',
                        },
                        {
                            key: 'used_hints',
                            name: 'Hints used since first step',
                        },
                        {
                            key: 'energy_current',
                            name: 'Energy Current',
                        },
                        {
                            key: 'gems_current',
                            name: 'Gems Current',
                        },
                        {
                            key: 'hints_current',
                            name: 'Hints Current',
                        },
                    ];
                },
            },
            colorGetterBuilder: (context: IQueryContext) => {
                return defaultColorGetterBuilder(this.colorService, context);
            },
        }),
        dataLoaderEmitter:
            this.chartDataLoaders[
                'mopa.custom_funnels.custom_funnels_users_by_step'
            ].emitter,
    };

    funnels_percentage_change_from_previous_step: IDashboardItemDataLoaderLink =
        {
            id: 'mopa.custom_funnels.chart.funnels_percentage_change_from_previous_step',
            dashboardItemFactory: DashboardItemFactories[
                'common.chart.xy_chart'
            ]({
                dashboardName: this.DASHBOARD_NAME,
                createdInstanceId:
                    'mopa.custom_funnels.chart.funnels_percentage_change_from_previous_step',
                dashboardItem: {
                    title: '% change from previous step',
                    chartDocumentation:
                        MopaCustomFunnelsChartDocs.funnels_percentage_change_from_previous_step,
                },
                xAxisType: 'category',
                xAxisCategorySubtype: 'generic',
                xColumnLabel: 'step_id_str',
                yColumnLabel: 'percentage_change_from_previous_step',
                yAxisLabel: {
                    formatter: (v: number) =>
                        EChartsAxisHelper.axisPercentLabelFormatter(v, 0),
                },
                metricName: '% change from previous step',
                echartsSeriesType: 'bar',
                toolbox: {
                    feature: {
                        export: {
                            customColumns: [
                                {
                                    key: 'step_id',
                                    name: 'Step ID',
                                    rowKey: true,
                                },
                                {
                                    key: 'step_name',
                                    name: 'Step Name',
                                    rowKey: true,
                                    sortKey: true,
                                },
                                {
                                    key: 'step_group',
                                    name: 'Step Group',
                                    rowKey: true,
                                },
                                {
                                    key: 'percentage_change_from_previous_step',
                                    name: '% change from previous step',
                                },
                            ],
                        },
                    },
                },
                tooltip: {
                    valueFormatterGetter: () =>
                        EChartsTooltipHelper.tooltipPercentValueFormatter,
                    secondaryMetricsGetter: (context) => {
                        return [
                            {
                                key: 'step_name',
                                name: 'Step Name',
                            },
                            {
                                key: 'step_group',
                                name: 'Step Group',
                            },
                        ];
                    },
                },
                colorGetterBuilder: (context: IQueryContext) => {
                    return defaultColorGetterBuilder(
                        this.colorService,
                        context
                    );
                },
            }),
            dataLoaderEmitter:
                this.chartDataLoaders[
                    'mopa.custom_funnels.custom_funnels_users_by_step'
                ].emitter,
        };

    funnels_steps_with_median: IDashboardItemDataLoaderLink = {
        id: 'mopa.custom_funnels.chart.funnels_steps_with_median',
        dashboardItemFactory: DashboardItemFactories['common.chart.xy_chart']({
            dashboardName: this.DASHBOARD_NAME,
            createdInstanceId:
                'mopa.custom_funnels.chart.funnels_steps_with_median',
            dashboardItem: {
                title: 'Steps with median time on x-axis',
                subtitle: 'Time since first step in minutes',
                chartDocumentation:
                    MopaCustomFunnelsChartDocs.funnels_steps_with_median,
            },
            xAxisType: 'value',
            xColumnLabel: 'time_since_first_step_min_Q2',
            yColumnLabel: 'percentage_of_first_step',
            yAxisLabel: {
                formatter: (v: number) =>
                    EChartsAxisHelper.axisPercentLabelFormatter(v, 0),
            },
            // metricName: '% of first step',
            metricName: ' ',
            echartsSeriesType: 'line',
            seriesSymbolMethod: 'every',
            toolbox: {
                feature: {
                    export: {
                        customColumns: [
                            {
                                key: 'step_id',
                                name: 'Step ID',
                                rowKey: true,
                            },
                            {
                                key: 'step_name',
                                name: 'Step Name',
                                rowKey: true,
                                sortKey: true,
                            },
                            {
                                key: 'step_group',
                                name: 'Step Group',
                                rowKey: true,
                            },
                            {
                                key: 'users_by_step',
                                name: 'Users',
                            },
                            {
                                key: 'percentage_of_first_step',
                                name: '% of first step',
                            },
                            {
                                key: 'percentage_of_previous_step',
                                name: '% of previous step',
                            },
                            {
                                key: 'used_energy_Q2',
                                name: 'Used energy Q2',
                            },
                            {
                                key: 'time_since_first_step_min_Q2',
                                name: 'Time since first step Q2',
                            },
                            {
                                key: 'time_since_previous_step_sec_Q2',
                                name: 'Time since previous step Q2',
                            },
                        ],
                    },
                },
            },
            tooltip: {
                xLabelFormatterGetter(context) {
                    return (value: number) => `${value} [min]`;
                },
                valueFormatterGetter: () => () => '',
                // EChartsTooltipHelper.tooltipPercentValueFormatter,
                secondaryMetricsGetter: (context) => {
                    return [
                        {
                            key: 'step_name',
                            name: 'Step',
                        },
                        {
                            key: 'step_group',
                            name: 'Step Group',
                        },
                        {
                            key: 'percentage_of_first_step',
                            name: '% of first step',
                            formatter:
                                EChartsTooltipHelper.tooltipPercentValueFormatter,
                        },
                        {
                            key: 'users_by_step',
                            name: 'Users',
                        },
                        {
                            key: 'percentage_of_previous_step',
                            name: '% of previous step',
                            formatter:
                                EChartsTooltipHelper.tooltipPercentValueFormatter,
                        },
                        {
                            name: 'Q1-Q2 (Median)-Q3 Statistics',
                        },
                        {
                            key: 'used_energy',
                            name: 'Used energy',
                        },
                        {
                            key: 'time_since_first_step_min',
                            name: 'Time since first step',
                        },
                        {
                            key: 'time_since_previous_step_sec',
                            name: 'Time since previous step',
                        },
                        {
                            name: 'Data quality',
                        },
                        {
                            key: 'used_energy_not_null',
                            name: 'Used energy not null',
                        },
                    ];
                },
            },
            colorGetterBuilder: (context: IQueryContext) => {
                return defaultColorGetterBuilder(this.colorService, context);
            },
        }),
        dataLoaderEmitter:
            this.chartDataLoaders[
                'mopa.custom_funnels.custom_funnels_users_by_step'
            ].emitter,
    };

    settingOpenClosedFunnels: IToggleSettingDashboardItem = {
        options: {
            id: QueryContextSettingID.CUSTOM_FUNNELS_OPEN_CLOSED,
            viewtype: 'toggle',
            displayName: 'Funnels Type',
            selectOptions: ['closed', 'open'],
            description:
                'OPEN funnel ignores event order, CLOSED funnel respects event order',
        },
    };

    // FILTERS
    filterDashboardItemLinks: Partial<
        Record<DatasourceColumnId, IDashboardItemDataLoaderLink>
    > = {
        CUSTOM_FUNNELS_FUNNEL_NAME: {
            id: 'mopa.custom_funnels.filter.funnel_name',
            dashboardItemFactory: DashboardItemFactories['filter.category']({
                createdInstanceId: 'mopa.custom_funnels.filter.funnel_name',
                datasourceColumnId: 'CUSTOM_FUNNELS_FUNNEL_NAME',
                splitable: false,
                selectMode: 'single',
            }),
            dataLoaderEmitter:
                this.filterDataLoaders['mopa.custom_funnels.filter.funnel_name']
                    .emitter,
        },
        CUSTOM_FUNNELS_STEP_GROUP: {
            id: 'mopa.custom_funnels.filter.step_group',
            dashboardItemFactory: DashboardItemFactories['filter.category']({
                createdInstanceId: 'mopa.custom_funnels.filter.step_group',
                datasourceColumnId: 'CUSTOM_FUNNELS_STEP_GROUP',
                splitable: false,
            }),
            dataLoaderEmitter:
                this.filterDataLoaders['mopa.custom_funnels.filter.step_group']
                    .emitter,
        },
        CUSTOM_FUNNELS_STEP_ID: {
            id: 'mopa.custom_funnels.filter.step_id',
            dashboardItemFactory: DashboardItemFactories['filter.category']({
                createdInstanceId: 'mopa.custom_funnels.filter.step_id',
                datasourceColumnId: 'CUSTOM_FUNNELS_STEP_ID',
                splitable: false,
            }),
            dataLoaderEmitter:
                this.filterDataLoaders['mopa.custom_funnels.filter.step_id']
                    .emitter,
        },
        CUSTOM_FUNNELS_STEP_NAME: {
            id: 'mopa.custom_funnels.filter.step_name',
            dashboardItemFactory: DashboardItemFactories['filter.category']({
                createdInstanceId: 'mopa.custom_funnels.filter.step_name',
                datasourceColumnId: 'CUSTOM_FUNNELS_STEP_NAME',
                splitable: false,
            }),
            dataLoaderEmitter:
                this.filterDataLoaders['mopa.custom_funnels.filter.step_name']
                    .emitter,
        },
        // CUSTOM_FUNNELS_OUT_REPLAYS: {
        //     id: 'mopa.custom_funnels.filter.out_replays',
        //     dashboardItemFactory: DashboardItemFactories['filter.category']({
        //         createdInstanceId: 'mopa.custom_funnels.filter.out_replays',
        //         datasourceColumnId: 'CUSTOM_FUNNELS_OUT_REPLAYS',
        //     }),
        //     dataLoaderEmitter:
        //         this.filterDataLoaders['mopa.custom_funnels.filter.out_replays']
        //             .emitter,
        // },
        // CUSTOM_FUNNELS_FIRST_GAME_ENI2: {
        //     id: 'mopa.custom_funnels.filter.first_game_eni2',
        //     dashboardItemFactory: DashboardItemFactories['filter.category']({
        //         createdInstanceId: 'mopa.custom_funnels.filter.first_game_eni2',
        //         datasourceColumnId: 'CUSTOM_FUNNELS_FIRST_GAME_ENI2',
        //     }),
        //     dataLoaderEmitter:
        //         this.filterDataLoaders[
        //             'mopa.custom_funnels.filter.first_game_eni2'
        //         ].emitter,
        // },
        // ACTIVITY_DATE: {
        //     id: 'mopa.custom_funnels.filter.activity_date',
        //     dashboardItemFactory: DashboardItemFactories['filter.daterange']({
        //         createdInstanceId: 'mopa.custom_funnels.filter.activity_date',
        //         datasourceColumnId: 'ACTIVITY_DATE',
        //         forcedSplitable: true,
        //     }),
        //     // empty emitter DataRangePicker doesn't need data
        //     dataLoaderEmitter: new EventEmitter<IDataLoaderResult>(),
        // },
        SEGMENT: {
            id: 'mopa.custom_funnels.filter.segment',
            dashboardItemFactory: DashboardItemFactories['filter.segments']({
                createdInstanceId: 'mopa.custom_funnels.filter.segment',
                datasourceColumnId: 'SEGMENT',
            }),
            dataLoaderEmitter:
                this.filterDataLoaders['mopa.custom_funnels.filter.segment']
                    .emitter,
        },
        FIREBASE_FIRST_OPEN_DATE: {
            id: 'mopa.custom_funnels.filter.firebase_first_open_date',
            dashboardItemFactory: DashboardItemFactories['filter.daterange']({
                createdInstanceId:
                    'mopa.custom_funnels.filter.firebase_first_open_date',
                datasourceColumnId: 'FIREBASE_FIRST_OPEN_DATE',
                splitable: true,
            }),
            // empty emitter DataRangePicker doesn't need data
            dataLoaderEmitter: new EventEmitter<IDataLoaderResult>(),
        },
        FIREBASE_APP_STORE: {
            id: 'mopa.custom_funnels.filter.firebase_app_store',
            dashboardItemFactory: DashboardItemFactories['filter.category']({
                createdInstanceId:
                    'mopa.custom_funnels.filter.firebase_app_store',
                datasourceColumnId: 'FIREBASE_APP_STORE',
            }),
            dataLoaderEmitter:
                this.filterDataLoaders[
                    'mopa.custom_funnels.filter.firebase_app_store'
                ].emitter,
        },
        FIREBASE_COUNTRY_EUROPEAN_UNION: {
            id: 'mopa.custom_funnels.filter.firebase_country_european_union',
            dashboardItemFactory: DashboardItemFactories['filter.category']({
                createdInstanceId:
                    'mopa.custom_funnels.filter.firebase_country_european_union',
                datasourceColumnId: 'FIREBASE_COUNTRY_EUROPEAN_UNION',
            }),
            dataLoaderEmitter:
                this.filterDataLoaders[
                    'mopa.custom_funnels.filter.firebase_country_european_union'
                ].emitter,
        },
        FIREBASE_COUNTRY_TIER: {
            id: 'mopa.custom_funnels.filter.firebase_country_tier',
            dashboardItemFactory: DashboardItemFactories['filter.category']({
                createdInstanceId:
                    'mopa.custom_funnels.filter.firebase_country_tier',
                datasourceColumnId: 'FIREBASE_COUNTRY_TIER',
            }),
            dataLoaderEmitter:
                this.filterDataLoaders[
                    'mopa.custom_funnels.filter.firebase_country_tier'
                ].emitter,
        },
        FIREBASE_COUNTRY_IS_RELEVANT_LABEL: {
            id: 'mopa.custom_funnels.filter.firebase_country_is_relevant_label',
            dashboardItemFactory: DashboardItemFactories['filter.category']({
                createdInstanceId:
                    'mopa.custom_funnels.filter.firebase_country_is_relevant_label',
                datasourceColumnId: 'FIREBASE_COUNTRY_IS_RELEVANT_LABEL',
            }),
            dataLoaderEmitter:
                this.filterDataLoaders[
                    'mopa.custom_funnels.filter.firebase_country_is_relevant_label'
                ].emitter,
        },
        FIREBASE_COUNTRY: {
            id: 'mopa.custom_funnels.filter.firebase_country',
            dashboardItemFactory: DashboardItemFactories['filter.category']({
                createdInstanceId:
                    'mopa.custom_funnels.filter.firebase_country',
                datasourceColumnId: 'FIREBASE_COUNTRY',
            }),
            dataLoaderEmitter:
                this.filterDataLoaders[
                    'mopa.custom_funnels.filter.firebase_country'
                ].emitter,
        },
        ATTRIBUTION_TRAFFIC_SOURCE: {
            id: 'mopa.custom_funnels.filter.attribution_traffic_source',
            dashboardItemFactory: DashboardItemFactories['filter.category']({
                createdInstanceId:
                    'mopa.custom_funnels.filter.attribution_traffic_source',
                datasourceColumnId: 'ATTRIBUTION_TRAFFIC_SOURCE',
            }),
            dataLoaderEmitter:
                this.filterDataLoaders[
                    'mopa.custom_funnels.filter.attribution_traffic_source'
                ].emitter,
        },
        ATTRIBUTION_NETWORK_NAME: {
            id: 'mopa.custom_funnels.filter.attribution_network_name',
            dashboardItemFactory: DashboardItemFactories['filter.category']({
                createdInstanceId:
                    'mopa.custom_funnels.filter.attribution_network_name',
                datasourceColumnId: 'ATTRIBUTION_NETWORK_NAME',
            }),
            dataLoaderEmitter:
                this.filterDataLoaders[
                    'mopa.custom_funnels.filter.attribution_network_name'
                ].emitter,
        },
        FIREBASE_INSTALL_VERSION_GROUP_MINOR: {
            id: 'mopa.custom_funnels.filter.firebase_install_version_group_minor',
            dashboardItemFactory: DashboardItemFactories['filter.category']({
                createdInstanceId:
                    'mopa.custom_funnels.filter.firebase_install_version_group_minor',
                datasourceColumnId: 'FIREBASE_INSTALL_VERSION_GROUP_MINOR',
            }),
            dataLoaderEmitter:
                this.filterDataLoaders[
                    'mopa.custom_funnels.filter.firebase_install_version_group_minor'
                ].emitter,
        },
        FIREBASE_INSTALL_VERSION: {
            id: 'mopa.custom_funnels.filter.firebase_install_version',
            dashboardItemFactory: DashboardItemFactories['filter.category']({
                createdInstanceId:
                    'mopa.custom_funnels.filter.firebase_install_version',
                datasourceColumnId: 'FIREBASE_INSTALL_VERSION',
            }),
            dataLoaderEmitter:
                this.filterDataLoaders[
                    'mopa.custom_funnels.filter.firebase_install_version'
                ].emitter,
        },
        ETL_PAYER: {
            id: 'mopa.custom_funnels.filter.payer',
            dashboardItemFactory: DashboardItemFactories['filter.category']({
                createdInstanceId: 'mopa.custom_funnels.filter.payer',
                datasourceColumnId: 'ETL_PAYER',
            }),
            dataLoaderEmitter:
                this.filterDataLoaders['mopa.custom_funnels.filter.payer']
                    .emitter,
        },
        ETL_REVENUE_BADGE: {
            id: 'mopa.custom_funnels.filter.revenue_badge',
            dashboardItemFactory: DashboardItemFactories['filter.category']({
                createdInstanceId: 'mopa.custom_funnels.filter.revenue_badge',
                datasourceColumnId: 'ETL_REVENUE_BADGE',
            }),
            dataLoaderEmitter:
                this.filterDataLoaders[
                    'mopa.custom_funnels.filter.revenue_badge'
                ].emitter,
        },
        ATTRIBUTION_CAMPAIGN_NAME: {
            id: 'mopa.custom_funnels.filter.attribution_campaign_name',
            dashboardItemFactory: DashboardItemFactories['filter.category']({
                createdInstanceId:
                    'mopa.custom_funnels.filter.attribution_campaign_name',
                datasourceColumnId: 'ATTRIBUTION_CAMPAIGN_NAME',
            }),
            dataLoaderEmitter:
                this.filterDataLoaders[
                    'mopa.custom_funnels.filter.attribution_campaign_name'
                ].emitter,
        },
    };

    override ngOnInit() {
        super.ngOnInit();
        console.log({
            msg: 'MopaCustomFunnelsComponent.ngOnInit',
            cancellationToken: this.cancellationToken,
        });
    }
    ngAfterViewInit() {
        console.log({
            msg: 'MopaCustomFunnelsComponent.ngAfterViewInit',
            cancellationToken: this.cancellationToken,
        });

        this.standardDashboardInitialize();
    }

    override getInitialContext(): IQueryContext {
        const initialContext = QueryContextService.INITIAL_CONTEXT;

        const funnelIC: IMultipleSelectDashboardItem['datasourceColumn'] = {
            id: 'CUSTOM_FUNNELS_FUNNEL_NAME',
            state: {
                value: {
                    options: ['ftue_unsolved'],
                    filterType: 'include',
                },
                isFilterApplied: true,
                isSplitApplied: false,
            },
        };

        // const activityDateIC: IDateRangePickerDashboardItem['datasourceColumn'] =
        //     {
        //         id: 'ACTIVITY_DATE',
        //         state: {
        //             value: {
        //                 preset: 'custom',
        //                 splitAggregate: 'day',
        //                 // start 2025-10-01
        //                 start: new Date(2025, 9, 1),
        //             },
        //             isFilterApplied: true,
        //             isSplitApplied: false,
        //         },
        //     };

        const firstSessionDateIC: IDateRangePickerDashboardItem['datasourceColumn'] =
            {
                id: 'FIREBASE_FIRST_OPEN_DATE',
                state: {
                    value: {
                        preset: 'last 30 days',
                        splitAggregate: 'day',
                    },
                    isFilterApplied: true,
                    isSplitApplied: false,
                },
            };

        initialContext.datasourceColumns = [
            funnelIC,
            // activityDateIC,
            firstSessionDateIC,
        ];

        initialContext.settings['customfunnels.openClosed'] = 'open';

        return initialContext;
    }
}
